import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultValue", "onTabChange", "children"];
import { Children, useState } from 'react';
import clsx from 'clsx';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../_shadcn-native-components/tabs";
import { Button } from "../Button/Button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ContentTabsRoot = function ContentTabsRoot(_ref) {
  var defaultValue = _ref.defaultValue,
    onTabChange = _ref.onTabChange,
    children = _ref.children,
    tabProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var handleTabChange = function handleTabChange(value) {
    setCurrentTab(value);
    onTabChange(value);
  };
  return /*#__PURE__*/_jsx(Tabs, _objectSpread(_objectSpread({
    value: currentTab,
    onValueChange: handleTabChange
  }, tabProps), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: "tw-flex tw-flex-col tw-w-full",
      children: children
    })
  }));
};
var ContentTabsList = function ContentTabsList(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  var tabCount = Children.count(children);
  return /*#__PURE__*/_jsx(TabsList, {
    className: clsx('tw-w-full tw-bg-neutral-light-100 tw-border-solid tw-border-[1px] tw-border-primary-light-500 tw-rounded-1', className),
    style: {
      display: 'grid',
      gridTemplateColumns: "repeat(".concat(tabCount, ", 1fr)")
    },
    children: children
  });
};
var ContentTabsTrigger = function ContentTabsTrigger(_ref3) {
  var label = _ref3.label,
    value = _ref3.value,
    icon = _ref3.icon,
    disabled = _ref3.disabled,
    className = _ref3.className;
  return /*#__PURE__*/_jsx(TabsTrigger, {
    asChild: true,
    name: value,
    value: value,
    disabled: disabled,
    className: clsx('tw-flex tw-flex-grow tw-flex-shrink tw-basis-auto tw-justify-center', className),
    children: /*#__PURE__*/_jsx(Button, {
      className: clsx('tw-w-full', !disabled && 'data-[state=inactive]:tw-bg-transparent data-[state=inactive]:tw-text-primary-light-500', !disabled && 'data-[state=active]:tw-bg-primary-light-500 data-[state=active]:tw-text-neutral-light-100', disabled ? 'tw-cursor-default' : 'tw-cursor-pointer'),
      style: {
        borderRadius: 'calc(1rem - 1px)'
      },
      variant: disabled ? 'cancel' : 'primary',
      disabled: disabled,
      type: "button",
      size: "xs",
      children: /*#__PURE__*/_jsxs("span", {
        className: "tw-flex tw-items-center tw-gap-1",
        children: [icon && /*#__PURE__*/_jsx("span", {
          children: icon({
            size: 20,
            className: 'tw-flex tw-text-current tw-self-center'
          })
        }), label]
      })
    })
  });
};
var ContentTabsContent = TabsContent;
var ContentTabsWithComponents = ContentTabsRoot;
ContentTabsWithComponents.List = ContentTabsList;
ContentTabsWithComponents.Trigger = ContentTabsTrigger;
ContentTabsWithComponents.Content = ContentTabsContent;
export var ContentTabs = ContentTabsWithComponents;